import React, { useMemo } from 'react';

const romanNumerals = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];
const alphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];

const PhaseTitle = React.memo(({ phase, type, parametres }) => {
  const titreAffiche = useMemo(() => {
    if (phase === 0) {
      return "En attente";
    } else if (type === "plan") {
      const jsonParametres = typeof parametres === 'string' ? JSON.parse(parametres) : parametres;
      const parties = jsonParametres?.parties || 0;
      const sousparties = jsonParametres?.sousparties || 0;

      const phasesPerPartie = 1 + sousparties;
      const phaseGroupIndex = Math.floor((phase - 1) / 2);
      const partieIndex = Math.floor(phaseGroupIndex / phasesPerPartie);
      const subPartieIndex = phaseGroupIndex % phasesPerPartie;

      if (subPartieIndex === 0) {
        return `Partie ${romanNumerals[partieIndex] || (partieIndex + 1)}`;
      } else {
        return `Sous-partie ${romanNumerals[partieIndex] || (partieIndex + 1)}.${alphabet[subPartieIndex - 1] || subPartieIndex}`;
      }
    } else if (type === "redaction") {
      return `Phase ${Math.floor((phase + 1) / 2)}`;
    }
    return '';
  }, [phase, type, parametres]);

  return <>{titreAffiche}</>;
}, (prevProps, nextProps) => {
  return prevProps.phase === nextProps.phase &&
         prevProps.type === nextProps.type &&
         JSON.stringify(prevProps.parametres) === JSON.stringify(nextProps.parametres);
});

PhaseTitle.displayName = 'PhaseTitle';

export default PhaseTitle;